/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _config = require('../config');

var _captcha = require('../../helper/captcha');

var _browser = require('../../helper/browser');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable no-console */
/* eslint-disable indent */
var Appointment = function () {
  function Appointment(actHashId) {
    (0, _classCallCheck3["default"])(this, Appointment);

    // 频道id
    this.actHashId = actHashId;
    // 记录人机验证的渲染目标元素ID
    this.renderTo = '';
    // 阿里人机验证数据存储
    this.captchaData = {
      token: '',
      session_id: '',
      sig: ''
    };
    // 是否已订阅服务端im消息
    this.hasSubIMMsg = false;
  }

  /**
   * 发起预约变更的事实消息监听
   */


  (0, _createClass3["default"])(Appointment, [{
    key: '_subAppointmentChange',
    value: function _subAppointmentChange() {
      // 目前只有预约使用im连接，用户注册预约模块监听时再连接
      imClient.manualConnect();
      imClient.on('appointment', function (msg) {
        _scope.MsgBus.Pub('Appointment.Change', msg);
      });
    }

    /**
     * 发起预约变更的事实消息监听
     * 一般在点击预约前就发起当前预约变更监听
     * @param {Function} cb 预约变更的回调
     */

  }, {
    key: 'AddAppointmentChangeListening',
    value: function AddAppointmentChangeListening(cb) {
      if (!this.hasSubIMMsg) {
        this._subAppointmentChange();
        this.hasSubIMMsg = true;
      }
      _scope.MsgBus.On('Appointment.Change', function (res) {
        var data = JSON.parse(res);
        typeof cb === 'function' && cb(data);
      });
    }

    /**
     * 发起初始化阿里人机验证
     * 请在点击预约前发起初始化阿里人机验证
     * @param {string} renderTo 声明智能验证需要渲染的目标元素ID。
     * @param {number} width 智能验证组件的宽度。
     * @param {number} height 智能验证组件的高度。
     */

  }, {
    key: 'InitCaptcha',
    value: function InitCaptcha(renderTo, width, height) {
      var _this = this;

      if (!this._isSingleCaptcha(renderTo)) return;
      var params = {
        width: width,
        height: height,
        renderTo: renderTo,
        isH5: (0, _browser.isMobile)(),
        success: function success(res) {
          res = res || {};
          _this.captchaData.sig = res.sig || '';
          _this.captchaData.token = res.token || '';
          _this.captchaData.session_id = res.sessionId || '';
          console.log('阿里人机验证获取到的数据:', _this.captchaData);
        },
        fail: function fail() {
          _this._resetCaptchaData();
        }
      };
      (0, _captcha.initCaptcha)(params, function (resetCaptcha) {
        _this.ResetCaptcha = resetCaptcha;
      });
    }

    /**
     * 点击预约
     * @param {number} appointmentId 预约id
     * @param {string} phone 手机号
     * @param {Function} cb 预约后回调
     */

  }, {
    key: 'SubmitAppointmentInfo',
    value: function SubmitAppointmentInfo(appointmentId, phone, cb) {
      var _this2 = this;

      // 如果没有人机验证通过，则不发起预约
      if (!this.captchaData.session_id || !this.captchaData.token || !this.captchaData.sig) {
        console.warn('没有通过人机验证，请先人机验证通过后再发起预约');
        return;
      }
      var url = _config.API_DOMAIN_V2 + ('/v2/watch/' + this.actHashId + '/micro-act/view/appointment/point');
      var params = (0, _extends3["default"])({
        phone: phone,
        appointment_id: Number(appointmentId),
        scene: (0, _browser.isMobile)() ? 'ic_message_h5' : 'ic_message'
      }, this.captchaData);
      console.log('点击预约发送的参数:', params);
      var callback = function callback(res) {
        _this2.ResetCaptcha();
        _this2._resetCaptchaData();
        var cbData = JSON.parse(res);
        typeof cb === 'function' && cb(cbData);
      };
      Fetcher.Post(url, (0, _stringify2["default"])(params), callback, (0, _extends3["default"])({
        'Content-Type': 'application/json'
      }, _scope.DB.Get('requestHeader').session));
    }

    /**
     * 获取观看页预约信息
     * @param {Function} cb 预览信息回调
     */

  }, {
    key: 'GetAppointmentInfo',
    value: function GetAppointmentInfo(cb) {
      var url = _config.API_DOMAIN_V2 + '/v2/watch/' + this.actHashId + '/micro-act/view/appointment/info';
      Fetcher.Get(url, function (res) {
        var cbData = JSON.parse(res);
        typeof cb === 'function' && cb(cbData);
      }, _scope.DB.Get('requestHeader').session);
    }

    // 重置阿里人机校验 会被覆盖重写

  }, {
    key: 'ResetCaptcha',
    value: function ResetCaptcha() {
      console.warn('ResetCaptcha 调用出错，请先调用InitCaptcha');
    }

    /**
     * 重置阿里人机验证数据存储
     */

  }, {
    key: '_resetCaptchaData',
    value: function _resetCaptchaData() {
      this.captchaData.sig = '';
      this.captchaData.token = '';
      this.captchaData.session_id = '';
    }

    /**
     * 判断是否已经初始化了人机验证
     * @param {string} renderTo 声明智能验证需要渲染的目标元素ID。
     * @returns 是否已经初始化了人机验证
     */

  }, {
    key: '_isSingleCaptcha',
    value: function _isSingleCaptcha(renderTo) {
      if (!this.renderTo || this.renderTo === renderTo) {
        this.renderTo = renderTo;
        return true;
      } else {
        console.warn('同一个环境目前只允许初始化一个人机验证');
        return true;
      }
    }
  }]);
  return Appointment;
}();

module.exports = Appointment;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/core/Appointment.js
 ** module id = 187
 ** module chunks = 1
 **/